import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Weighings } from 'src/app/data/model/weighing';

@Component({
  standalone: false,
  selector: 'app-vehicle-last-weighing-dialog',
  templateUrl: './vehicle-last-weighing-dialog.component.html',
  styleUrls: ['./vehicle-last-weighing-dialog.component.scss']
})
export class VehicleLastWeighingDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Weighings
  ) { }

  displayedColumns: string[] = [
    'device_timestamp',
    'weight'
  ];

  dataSource = new MatTableDataSource<Weighings>([
    this.data
  ]);


}
